import { checkLang, getUserLangFromCookie } from '@app/utils/checkLang'

export default ({ app }: { app: any }) => {
  checkLang()
}
